import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const React = require("react");
import { slugify } from "../../custom_utils/helpers";
import { getWordCloudTags } from "./formstack/formstack_api";
import { Block, Container } from "./library/container";
import { Link } from "./library/link";
const initialState = {
    tags: {
        kind: null,
        status: null
    }
};
const renderDescription = (contents, htmlElement, jsxElement)=>{
    return typeof contents == "string" ? /*#__PURE__*/ _createElement(htmlElement.type, {
        ...htmlElement.props,
        key: htmlElement.key,
        dangerouslySetInnerHTML: {
            __html: contents
        }
    }) : /*#__PURE__*/ _jsx(jsxElement.type, {
        ...jsxElement.props,
        children: contents
    }, jsxElement.key);
};
export class WordCloudBlock extends React.Component {
    componentDidMount() {
        getWordCloudTags(this.props.form_id, this.props.field_id, this.props.number_of_options).then((result)=>this.setState((prevState)=>({
                    ...prevState,
                    tags: result
                })));
    }
    render() {
        const { title, description, label, primaryActionTitle, primaryActionUrl } = this.props;
        const tagsResult = this.state.tags;
        const tags = tagsResult.kind == initialState.tags.kind ? 'loading' : tagsResult.kind != 'result' ? 'failed' : tagsResult.value;
        return /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(Block, {
                children: /*#__PURE__*/ _jsxs("section", {
                    className: "cta cta--block cta--large",
                    children: [
                        title && /*#__PURE__*/ _jsx("header", {
                            className: "cta__header",
                            children: /*#__PURE__*/ _jsx("h2", {
                                "data-anchor": slugify(title),
                                className: "cta__title title--l",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "cta__content",
                            children: [
                                renderDescription(description, /*#__PURE__*/ _jsx("p", {
                                    className: "cta__text"
                                }), /*#__PURE__*/ _jsx("div", {})),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "cta__tags",
                                    children: [
                                        label && /*#__PURE__*/ _jsx("h3", {
                                            className: "cta__tags-title title--s",
                                            children: label
                                        }),
                                        tags == 'loading' ? /*#__PURE__*/ _jsx("div", {
                                            className: "cta__tags-loader",
                                            children: "Laden..."
                                        }) : tags == 'failed' ? /*#__PURE__*/ _jsx("div", {
                                            className: "cta__tags-loader",
                                            children: "Laden mislukt."
                                        }) : /*#__PURE__*/ _jsx("ul", {
                                            className: "cta__tags-list",
                                            children: tags.map((tag, index)=>/*#__PURE__*/ _jsx("li", {
                                                    className: "cta__tags-item",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "cta__tag",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "cta__tag-title",
                                                                children: tag.Key
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "cta__tag-count",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("span", {
                                                                        className: "cta__tag-number",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "sr-text",
                                                                                children: "Aantal geinteresseerden: "
                                                                            }),
                                                                            tag.Value
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "cta__tag-icon",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, `cta-tag-${index}`))
                                        })
                                    ]
                                })
                            ]
                        }),
                        primaryActionTitle && primaryActionUrl && /*#__PURE__*/ _jsx("footer", {
                            className: "cta__footer",
                            children: /*#__PURE__*/ _jsx(Link, {
                                url: primaryActionUrl,
                                className: "cta__button button",
                                children: primaryActionTitle
                            })
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = initialState;
    }
}
